import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';

export const loginItemList = trigger('loginItemList', [
  transition( ':enter', [
    query( '@loginItem',
      stagger(100, animateChild()), { optional: true })
  ])
]);

export const loginItem = trigger( 'loginItem', [
  transition( ':enter', [
    style({opacity: 0, transform: 'translateY(-100%)'}),
    animate('500ms 0.4s cubic-bezier(0.35, 0, 0.25, 1)')
  ])
]);
